import React from "react";
import { get } from "lodash";
import {
  BetButtons,
  Header,
  Tag,
  useMediaQuery,
  breakpoints,
  Paragraph,
  useColorTokens
} from "@tvg/design-system";
import betSelection from "@tvg/utils/betSelection";
import { getActiveButtons } from "@tvg/desktop-bet/src/utils/betUtils";
import { SaddleClothSilk } from "@tvg/design-system/web/shared";
import {
  Container,
  Row,
  RunnerInfo,
  ContainerPickNumber,
  BetButtonsContainer,
  ScrLabelContainer,
  ContainerRunnerInfo,
  CommentContainer,
  HorseNameContainer
} from "./styled-components";
import { Props } from "./types";
import PickNumber from "../../../Runner/components/PickNumberAnalyse";
import { RUNNERS_QA_LABEL } from "../contants";

import OddsButton from "../../../Runner/components/RunnerHeaderInfo/OddsButton";
import Odds from "../../../Runner/components/RunnerHeaderInfo/Odds";

const Runners = ({
  runners,
  trackDataSource,
  wagerType,
  selections,
  onClickBetButton = () => ({}),
  isWagerable = true,
  activeDatasource,
  activeSourceName,
  legPosition = 0,
  isScrollableRacecard,
  showSilks
}: Props) => {
  const isMobile = useMediaQuery(breakpoints.tablet.max.sm);
  const colorTokens = useColorTokens();
  const isSingleSelection =
    betSelection.getWagerTypesNames(wagerType).length === 1;

  return (
    <Container data-qa-label={RUNNERS_QA_LABEL.CONTAINER}>
      {runners
        ?.filter((runner) =>
          get(runner, `${activeDatasource}.freePick.info`, null)
        )
        .map((runner) => {
          const onClickBet = (
            type: string,
            _isActive: boolean,
            position?: number
          ) => {
            onClickBetButton(
              runner,
              type,
              isScrollableRacecard ? legPosition : position,
              activeSourceName
                ? `${activeSourceName.toLocaleLowerCase()}_race_card`
                : undefined
            );
          };
          const activeButtons = getActiveButtons(
            runner.biNumber?.toString(),
            isScrollableRacecard
              ? [selections[legPosition as number]]
              : selections
          );

          return (
            <Row
              key={runner.runnerName + runner.biNumber}
              data-qa-label={RUNNERS_QA_LABEL.RUNNER}
              isSingleSelection={isSingleSelection}
            >
              <ContainerRunnerInfo>
                <SaddleClothSilk
                  number={runner.number}
                  saddleColor={runner.saddleColor}
                  numberColor={runner.numberColor}
                  isScratched={runner.isScratched}
                  silkImage={runner.silkImage}
                  isDesktop={!isMobile}
                  showSilks={showSilks}
                />
                <RunnerInfo>
                  <HorseNameContainer>
                    <Header
                      qaLabel={RUNNERS_QA_LABEL.NAME}
                      tag="h3"
                      fontSize={16}
                      textOverflow="ellipsis"
                    >
                      {runner.runnerName}
                    </Header>
                    <ContainerPickNumber isScratched={runner.isScratched}>
                      <PickNumber
                        {...{
                          [activeDatasource]: get(
                            runner,
                            activeDatasource,
                            null
                          )
                        }}
                        trackDataSource={trackDataSource}
                      />
                    </ContainerPickNumber>
                  </HorseNameContainer>
                  <CommentContainer isScratched={runner.isScratched}>
                    <Paragraph
                      qaLabel="comment"
                      color={colorTokens.content.subtle}
                      fontFamily="regular"
                    >
                      {get(runner, `${activeDatasource}.freePick.info`, null)}
                    </Paragraph>
                  </CommentContainer>
                </RunnerInfo>
                {runner.isScratched && (
                  <ScrLabelContainer>
                    <Tag
                      size="m"
                      variant="info"
                      label="Scratched"
                      qaLabel="race-card-scratched-label"
                    />
                  </ScrLabelContainer>
                )}
                {isMobile &&
                  isWagerable &&
                  !runner.isScratched &&
                  (activeButtons.length === 1 ? (
                    <OddsButton
                      runnerBI={runner}
                      activeButtons={activeButtons}
                      onClickBetButton={onClickBet}
                    />
                  ) : (
                    <Odds runnerBI={runner} isDesktop={!isMobile} />
                  ))}
              </ContainerRunnerInfo>
              {(!isMobile || (isMobile && activeButtons.length > 1)) &&
                isWagerable &&
                !runner.isScratched && (
                  <BetButtonsContainer isSingleSelection={isSingleSelection}>
                    <BetButtons
                      wagerType={wagerType}
                      onPress={onClickBet}
                      activeButtons={activeButtons}
                    />
                  </BetButtonsContainer>
                )}
            </Row>
          );
        })}
    </Container>
  );
};

export default Runners;
